export enum ExistCpDataConstant {
  A = "ACTIVITY_DATA",
  S = "SETTING",
  G = "REDUCE_GOAL",
  I = "INVENTORY"
}